function scrollTo(container_id, element_id) {
  return new Promise((resolve) => {
    const elem = document.getElementById(element_id)
    elem.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    })

    let scrollTimeout

    scrollTimeout = setTimeout(() => {
      resolve()
    }, 100)

    const container = document.getElementById(container_id)
    container.addEventListener(
      'scroll',
      function scrollListener() {
        clearTimeout(scrollTimeout)
        scrollTimeout = setTimeout(() => {
          container.removeEventListener('scroll', scrollListener)
          resolve()
        }, 100)
      }.bind(this)
    )
  })
}

export { scrollTo }
